<ng-container *ngIf="loadFlag">
  <table>
    <tr class="loader">
      <td colspan="7">
        <div class="loader-container">
          <img class="table-loader" src="../../../../assets/images/loading.svg">
        </div>
      </td>
    </tr>
  </table>
</ng-container>

<div class="container-fluid" *ngIf="!loadFlag">
  <div class="row">
    <div class="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12">
      <h3 class="headings">PayPal Transactions Details</h3>
    </div>
    <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12 text-center text-sm-center text-md-center text-lg-center text-xl-right  pt-4">
      <button class="gray-btn mr-1" [routerLink]="backToList()"><i class="fa fa-arrow-left"></i> Back</button>
      <button class="detail-btn mr-1" *ngIf="canRefund && (transactionDetails.status === 'COMPLETED' || transactionDetails.status === 'PARTIALLY_REFUNDED')" (click)="doRefund()"><i class="fa fa-warning"></i> Refund</button>
      <button class="detail-btn mr-1" (click)="viewPDF()"><i class="fa fa-download"></i> Export PDF</button>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div  class="b_shadow mt-4">
        <div  class="card-heading py-4 px-4">
          <div  class="row">
            <div  class="col-md-5 col-lg-6 col-sm-5 col-5 left-heading">
              <span>Payment Details</span>
            </div>
          </div>
        </div>
        <div  class="detail-content p-4">
          <div  class="row">
            <div  class="col-lg-6 col-md-12 col-sm-12 col-12 mb-3">
              <div class="row mb-3">
                <div  class="col-md-5 col-lg-5 col-sm-5 col-5 bill-to text-ellipse">
                  <span  class="detail_desc">Internal (Payarc) ID:</span>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-7 col-7 bill-to-div details_info">
                  {{ transactionDetails.id }}
                </div>
              </div>
              <div class="row mb-3">
                <div  class="col-md-5 col-lg-5 col-sm-5 col-5 bill-to text-ellipse">
                  <span  class="detail_desc">Amount:</span>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-7 col-7 bill-to-div details_info">
                  {{ (transactionDetails.amount | currency:(transactionDetails.currency || 'USD'):'symbol':'1.2-2') + ' ' + (transactionDetails.currency || 'USD') }}
                </div>
              </div>
              <div class="row mb-3">
                <div  class="col-md-5 col-lg-5 col-sm-5 col-5 bill-to text-ellipse">
                  <span  class="detail_desc">PayPal Id:</span>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-7 col-7 bill-to-div details_info">
                  {{ transactionDetails.paypal_id }}
                </div>
              </div>
            </div>
            <div  class="col-lg-6 col-md-12 col-sm-12 col-12 mb-3">
              <div class="row mb-3">
                <div  class="col-md-5 col-lg-5 col-sm-5 col-5 bill-to text-ellipse">
                  <span  class="detail_desc">Customer Name:</span>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-7 col-7 bill-to-div details_info">
                  {{ transactionDetails.customer_name }}
                </div>
              </div>
              <div class="row mb-3">
                <div  class="col-md-5 col-lg-5 col-sm-5 col-5 bill-to text-ellipse">
                  <span  class="detail_desc">Customer Email:</span>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-7 col-7 bill-to-div details_info">
                  {{ transactionDetails.customer_email }}
                </div>
              </div>
              <div class="row mb-3">
                <div  class="col-md-5 col-lg-5 col-sm-5 col-5 bill-to text-ellipse">
                  <span  class="detail_desc">Type:</span>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-7 col-7 bill-to-div details_info">
                  {{ transactionDetails.type | uppercase }}
                </div>
              </div>
            </div>
          </div>
          <div  class="row">
            <div  class="col-lg-6 col-md-12 col-sm-12 col-12 mb-3">
              <div class="row mb-3">
                <div  class="col-md-5 col-lg-5 col-sm-5 col-5 bill-to text-ellipse">
                  <span  class="detail_desc">Status:</span>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-7 col-7 bill-to-div details_info">
                  {{ transactionDetails.status }}
                </div>
              </div>
              <div class="row">
                <div  class="col-md-5 col-lg-5 col-sm-5 col-5 bill-to text-ellipse">
                  <span  class="detail_desc">Transaction Date:</span>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-7 col-7 bill-to-div details_info">
                  {{ transactionDetails.created_at | date: 'MM/dd/yyyy hh:mm' }}
                </div>
              </div>
            </div>
            <div  class="col-lg-6 col-md-12 col-sm-12 col-12 mb-3">
              <div class="row" *ngIf="transactionDetails.payment_source !== ''">
                <div  class="col-md-5 col-lg-5 col-sm-5 col-5 bill-to text-ellipse">
                  <span  class="detail_desc">Payment Source:</span>
                </div>
                <div class="col-md-7 col-lg-7 col-sm-7 col-7 bill-to-div details_info">
                  <img src="/assets/images/{{ transactionDetails.payment_source.toLowerCase() }}-logo.png" width="140px" alt="{{ transactionDetails.payment_source }}">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
